import {createContext} from "react";

export const PackingContext  = createContext({
    cancellationReasons: [],
    openProductProblemDrawer: false,
    setOpenProductProblemDrawer: () => {},
    handleAllItemAreCancelled: () => {},
    handlePackItem: () => {},
    packingLoading: false
})
